import { Input, Space, Table, Tag } from 'antd';
import React, { useState, useRef } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import localeObjectTable from '../../Utils/localeObjectTable';
import PropTypes from 'prop-types';
import currencyFormatter from '../../Utils/currencyFormatter';
import Boton from '../Atoms/Boton';

const TablaHistorialGastado = ({ data, loading }) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: '0 8px 8px 8px'
        }}
        onKeyDown={(e) => e.stopPropagation()}>
        <Boton
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
          className="button-close-search-filter-table">
          X
        </Boton>
        <Input
          ref={searchInput}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block'
          }}
        />
        <Space>
          <Boton
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small">
            Buscar
          </Boton>
          <Boton onClick={() => clearFilters && handleReset(clearFilters)} size="small" danger>
            Limpiar
          </Boton>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      )
  });

  const tablaReporte = [
    {
      title: 'ID SOLICITUD',
      dataIndex: 'id_purchase',
      key: 'id_purchase',
      ...getColumnSearchProps('id_purchase'),
      sorter: (a, b) => a.id_purchase - b.id_purchase,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'CONFRIMADO POR',
      dataIndex: 'user_name',
      key: 'user_name',
      ...getColumnSearchProps('user_name'),
      sorter: (a, b) => a.user_name.localeCompare(b.user_name),
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'TOTAL',
      dataIndex: 'total',
      key: 'total',
      ...getColumnSearchProps('total'),
      sorter: (a, b) => a.total - b.total,
      sortDirections: ['ascend', 'descend'],
      render: (text) => currencyFormatter(text)
    },
    {
      title: 'EXCEDENTE',
      dataIndex: 'total_return',
      key: 'total_return',
      ...getColumnSearchProps('total_return'),
      sorter: (a, b) => {
        const numA = parseFloat(a.total_return) || 0;
        const numB = parseFloat(b.total_return) || 0;
        return numA - numB;
      },
      sortDirections: ['ascend', 'descend'],
      render: (text) => {
        const value = parseFloat(text);
        return isNaN(value) ? text : <Tag color="red-inverse">{currencyFormatter(value)}</Tag>;
      }
    }
  ];

  const newDataSOL = data?.map((item, index) => {
    return {
      key: index,
      id_purchase: item?.id_purchase,
      user_name: item?.user_name,
      created_at: item?.created_at,
      total: item.total,
      total_return: item.total_return
    };
  });
  return (
    <>
      <Table
        loading={loading}
        columns={tablaReporte}
        dataSource={newDataSOL}
        pagination={{
          position: ['bottomCenter'],
          defaultPageSize: 10,
          pageSizeOptions: [20, 40, 60, 80, 100],
          total: data.total,
          showTotal: (total, range) =>
            `Mostrando gastos del ${range[0]} al ${range[1]} de un total de ${total}`
        }}
        className="mt-4 mb-4"
        locale={localeObjectTable}
        scroll={{
          x: true
        }}
      />
    </>
  );
};

TablaHistorialGastado.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};
export default TablaHistorialGastado;
